/**
 * Outbound help destinations, in one place (CHAT-856 v6).
 *
 * Two components link to Support — the header's user menu and the About dialog —
 * and before this they pointed at two different pages: the dialog at the generic
 * support.cloudradial.com root, the menu at the ChatAI KB. One product, one
 * Support destination, so both read this constant.
 *
 * ── WHY A SHORTENER AND NOT THE KB URL ──────────────────────────────────────
 * radials.io/ChatKB is a redirect we control. The KB itself lives behind a
 * vendor URL with a numeric category id in it, and that is exactly the kind of
 * address that gets reorganised — a moved category, a re-platformed help centre,
 * a renamed space. Pointing at the real URL means every such move needs a code
 * change, a build and a release before Support works again. Pointing at the
 * redirect means it is a one-line change in the shortener, live immediately, for
 * every deployed version at once — including the ones customers are still on.
 *
 * So: do NOT "helpfully" resolve this to its current target. The indirection is
 * the feature. (The spec asserts this, and says the same thing.)
 *
 * Not a design token and not app config: it is a fixed external URL, the same in
 * every environment and for every tenant. The tenant-configurable help target is
 * a different thing entirely — that is the `help_uri` setting behind the header's
 * '?' (Knowledge Base) link.
 */
export const SUPPORT_URL = 'https://radials.io/ChatKB';
